module.exports = __webpack_public_path__ + "./images/yellow_marker2.7de931.jpg";